// TODO: types
export const valuesConverter = (data: any[]) => {
  return data.map((row) => {
    return {
      ...row,
      isThirdParty: row.isThirdParty ? 'TRUE' : 'FALSE',
      possibleTotalLoss: row.possibleTotalLoss ? 'TRUE' : 'FALSE',
    };
  });
};
